import _WizardStepsCtrl from './_WizardStepsCtrl';
import templateStr from 'text!./templates/wizard-sidebar-ribbon.html';
import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './styles/wizard-sidebar-ribbon-hashed.scss';

const template = cssUtil.hashTemplate(templateStr, styles);

export default function () {
    return {
        restrict: 'A',
        replace: true,
        template,
        controller: _WizardStepsCtrl,
        scope: {
            wizardTitle: '@'
        }
    };
}
